module.exports = __webpack_public_path__ + "img/hero-section-middle-bg.8bc02a4a.png";